<template>
  <div class="home-shell">
    <section class="home-hero">
      <div class="brand-card">
        <div class="logo-wrap">
          <img
            v-if="companyName"
            src="@/assets/winebar.png"
            alt="LotLedger Logo"
            class="logo"
          />
        </div>

        <p class="eyebrow">LotLedger Wine Bar</p>

        <h1 v-if="companyName">
          Welcome, {{ companyName }}
          <button
            @click="openEditPopup"
            class="edit-name-button"
            title="Edit company name"
          >
            ✎
          </button>
        </h1>

        <h1 v-else>
          Set up your Wine Bar
        </h1>
       

        <p class="hero-copy">
          Track distributor purchases, inventory, sales, expenses, and profitability from one sharp little back-office system.
        </p>

        <div v-if="!companyName" class="setup-panel">
          <p class="setup-text">Enter your company name to get started.</p>

          <div class="setup-actions">
            <input
              v-model="newCompanyName"
              placeholder="Enter Company Name..."
              class="input-field"
              @keyup.enter="saveCompany"
            />

            <button @click="saveCompany" class="primary-action">
              Save
            </button>
          </div>
        </div>
      </div>

      <div class="home-dashboard-preview">
        <div class="preview-card wide">
          <span>Purchases</span>
          <strong>Distributor Orders</strong>
        </div>

        <div class="preview-card">
          <span>Inventory</span>
          <strong>Bottles, Cases, Kegs</strong>
        </div>

        <div class="preview-card">
          <span>Sales</span>
          <strong>Margins & Flow</strong>
        </div>

        <div class="preview-card gold">
          <span>Reports</span>
          <strong>Profitability</strong>
        </div>
      </div>
    </section>

    <!-- EDIT COMPANY MODAL -->
    <div v-if="showEditPopup" class="modal-overlay">
      <div class="home-modal">
        <div class="modal-topline"></div>

        <header class="modal-header">
          <div>
            <p class="eyebrow">Company Settings</p>
            <h2>Edit Company Name</h2>
            <p>Update the name shown throughout LotLedger Wine Bar.</p>
          </div>

          <button
            type="button"
            @click="showEditPopup = false"
            class="icon-close"
          >
            ×
          </button>
        </header>

        <div class="modal-body">
          <label>
            <span>Company Name</span>
            <input
              v-model="newCompanyName"
              class="input-field"
              @keyup.enter="updateCompanyName"
            />
          </label>

          <footer class="modal-actions">
            <button
              type="button"
              @click="showEditPopup = false"
              class="cancel-action"
            >
              Cancel
            </button>

            <button
              type="button"
              @click="updateCompanyName"
              class="primary-action"
            >
              Save
            </button>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  data() {
    return {
      companyName: "",
      newCompanyName: "",
      showEditPopup: false
    };
  },

  async mounted() {
    try {
      const response = await api.get("/company");

      if (response.data.name) {
        this.companyName = response.data.name;
        this.newCompanyName = response.data.name;
      }
    } catch (error) {
      console.error("Error fetching company name:", error);
    }
  },

  methods: {
    openEditPopup() {
      this.newCompanyName = this.companyName;
      this.showEditPopup = true;
    },

    async updateCompanyName() {
      if (!this.newCompanyName.trim()) {
        alert("Company name is required.");
        return;
      }

      try {
        const response = await api.put("/company", {
          company_name: this.newCompanyName
        });

        this.companyName = response.data.company_name || this.newCompanyName;
        this.showEditPopup = false;
      } catch (err) {
        console.error("❌ Failed to update company name:", err);
      }
    },

    async saveCompany() {
      if (!this.newCompanyName.trim()) {
        alert("Company name is required.");
        return;
      }

      try {
        await api.post("/company", {
          company_name: this.newCompanyName
        });

        this.companyName = this.newCompanyName;
      } catch (error) {
        console.error("Error saving company name:", error);
      }
    }
  }
};
</script>

<style scoped>
.home-shell {
  min-height: calc(100vh - 80px);
  padding: 32px;
  color: #f7efe8;
  font-family: "Inter", "Poppins", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.home-hero {
  min-height: calc(100vh - 144px);
  display: grid;
  grid-template-columns: minmax(320px, 1.15fr) minmax(280px, 0.85fr);
  gap: 24px;
  align-items: stretch;
}

.brand-card,
.home-dashboard-preview {
  border-radius: 34px;
  border: 1px solid rgba(255, 255, 255, 0.09);
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.085), rgba(255, 255, 255, 0.035));
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.36);
  backdrop-filter: blur(18px);
}

.brand-card {
  padding: clamp(28px, 5vw, 52px);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.logo-wrap {
  margin-bottom: 18px;
}

.logo {
  width: min(520px, 85%);
  max-height: 220px;
  object-fit: contain;
  filter: drop-shadow(0 18px 34px rgba(0, 0, 0, 0.45));
}

.eyebrow {
  margin: 0 0 10px;
  color: #c8a66a;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 12px;
  font-weight: 900;
}

.brand-card h1 {
  margin: 0;
  max-width: 900px;
  color: #fff8f1;
  font-size: clamp(44px, 8vw, 86px);
  line-height: 0.92;
  letter-spacing: -0.075em;
  font-weight: 900;
}

.edit-name-button {
  width: 44px;
  height: 44px;
  margin-left: 10px;
  vertical-align: middle;
  border-radius: 999px;
  border: 1px solid rgba(200, 166, 106, 0.34);
  background: rgba(200, 166, 106, 0.14);
  color: #f1c979;
  cursor: pointer;
  font-size: 18px;
  font-weight: 900;
}

.edit-name-button:hover {
  background: rgba(200, 166, 106, 0.24);
}

.tagline {
  width: fit-content;
  margin: 22px 0 0;
  padding: 10px 16px;
  border-radius: 999px;
  color: #f1c979;
  background: rgba(200, 166, 106, 0.14);
  border: 1px solid rgba(200, 166, 106, 0.28);
  font-size: clamp(18px, 3vw, 28px);
  font-weight: 900;
  letter-spacing: -0.035em;
}

.hero-copy {
  max-width: 680px;
  margin: 22px 0 0;
  color: #cfc2bd;
  font-size: 18px;
  line-height: 1.55;
}

.setup-panel {
  margin-top: 34px;
  padding: 22px;
  border-radius: 26px;
  background: rgba(0, 0, 0, 0.24);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.setup-text {
  margin: 0 0 14px;
  color: #cfc2bd;
  font-size: 16px;
  font-weight: 700;
}

.setup-actions {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) auto;
  gap: 12px;
}

/* ---------- Preview Cards ---------- */

.home-dashboard-preview {
  padding: 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  align-content: center;
}

.preview-card {
  min-height: 150px;
  padding: 22px;
  border-radius: 28px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background:
    radial-gradient(circle at top left, rgba(143, 18, 63, 0.28), transparent 38%),
    rgba(0, 0, 0, 0.24);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.preview-card.wide {
  grid-column: 1 / -1;
  min-height: 190px;
  background:
    radial-gradient(circle at top left, rgba(194, 74, 47, 0.3), transparent 38%),
    rgba(0, 0, 0, 0.27);
}

.preview-card.gold {
  background:
    radial-gradient(circle at top left, rgba(200, 166, 106, 0.22), transparent 38%),
    rgba(0, 0, 0, 0.24);
}

.preview-card span {
  margin-bottom: 8px;
  color: #9b8f8b;
  font-size: 12px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.12em;
}

.preview-card strong {
  color: #fff8f1;
  font-size: clamp(22px, 4vw, 34px);
  line-height: 1;
  letter-spacing: -0.055em;
}

/* ---------- Inputs / Buttons ---------- */

.input-field {
  min-height: 54px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  outline: 0;
  background: rgba(6, 4, 6, 0.58);
  color: #fff8f1;
  padding: 0 16px;
  font-size: 16px;
  font-family: inherit;
}

.input-field::placeholder {
  color: #766c68;
}

.input-field:focus {
  border-color: rgba(200, 166, 106, 0.65);
  box-shadow: 0 0 0 3px rgba(200, 166, 106, 0.14);
}

.primary-action,
.cancel-action {
  min-height: 54px;
  padding: 0 22px;
  border-radius: 999px;
  border: 0;
  color: #fff8f1;
  font-weight: 900;
  font-size: 15px;
  cursor: pointer;
  transition:
    transform 0.14s ease,
    box-shadow 0.14s ease,
    background 0.14s ease;
}

.primary-action {
  background: linear-gradient(135deg, #8f123f, #c24a2f);
  box-shadow: 0 14px 32px rgba(194, 74, 47, 0.28);
}

.cancel-action {
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.11);
}

.primary-action:hover,
.cancel-action:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.24);
}

/* ---------- Modal ---------- */

.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 26px;
  background:
    radial-gradient(circle at top left, rgba(128, 18, 54, 0.34), transparent 36%),
    rgba(5, 3, 5, 0.78);
  backdrop-filter: blur(12px);
}

.home-modal {
  width: min(560px, 94vw);
  overflow: hidden;
  border-radius: 30px;
  background:
    linear-gradient(145deg, rgba(35, 22, 29, 0.98), rgba(14, 10, 14, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.11);
  color: #f7efe8;
  box-shadow: 0 34px 90px rgba(0, 0, 0, 0.55);
}

.modal-topline {
  height: 5px;
  background: linear-gradient(90deg, #8f123f, #c24a2f, #c8a66a);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 18px;
  padding: 26px 28px 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.modal-header h2 {
  margin: 0;
  font-size: 36px;
  line-height: 0.95;
  letter-spacing: -0.06em;
}

.modal-header p {
  margin: 10px 0 0;
  color: #cfc2bd;
  line-height: 1.45;
}

.icon-close {
  width: 46px;
  height: 46px;
  flex: 0 0 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.07);
  color: #fff8f1;
  font-size: 30px;
  line-height: 1;
  cursor: pointer;
}

.modal-body {
  padding: 22px 28px 28px;
}

.modal-body label {
  display: grid;
  gap: 8px;
}

.modal-body label span {
  color: #b9aaa4;
  font-size: 12px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 18px;
}

/* ---------- Responsive ---------- */

@media (max-width: 1000px) {
  .home-hero {
    grid-template-columns: 1fr;
  }

  .home-dashboard-preview {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 720px) {
  .home-shell {
    padding: 16px;
  }

  .brand-card {
    padding: 26px;
  }

  .logo {
    width: 100%;
  }

  .home-dashboard-preview {
    grid-template-columns: 1fr;
  }

  .preview-card.wide {
    grid-column: auto;
  }

  .setup-actions {
    grid-template-columns: 1fr;
  }

  .primary-action,
  .cancel-action {
    width: 100%;
  }

  .modal-header {
    flex-direction: column;
  }

  .modal-actions {
    flex-direction: column;
  }
}
</style>